import React, { useEffect } from "react";
import styles from "./Table_3SP.module.css";

const Table3SP = ({
  dataType,
  resultData,
  setCordZcutoff,
  setCordX,
  setCordZ,
  isClicked3Sp,
  setIsClicked3SP
}) => {
  const columns = [
    "id",
    "p_value",
    "fdr p-value",
    "cut_off 0.05",
    "cut_off 0.01",
    "cut_off 0.001",
    "pathway",
    "source",
    "overlap",
    "level",
    "Viusalize",
  ];

  // useEffect(() => {
  //   console.log(resultData);
  //   console.log('-------------------------RESULT------------------------')
  // },[])

  return (
    <div className={styles.table}>
      <table>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column} className={styles.th}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className={styles.tbody}>
          {resultData.map(
            (
              {
                pvalue_string,
                qvalue,
                q_005,
                q_001,
                q_0001,
                pathway,
                source,
                size,
                overlap,
                cancerLevel,
                q_0001_val,
                q_001_val,
                q_005_val,
                pvalue,
              },
              index
            ) => (
              <tr
                key={
                  pvalue_string + pathway + size + overlap + cancerLevel + index
                }
              >
                <td className={`${styles.td} ${isClicked3Sp === pathway+index ? styles.clicked : ''}`} style={{ maxWidth: "25px" }}>
                  {index + 1}
                </td>
                <td style={{ minWidth: "50px" }} className={`${styles.td} ${isClicked3Sp === pathway+index ? styles.clicked : ''}`}>
                  {pvalue_string}
                </td>
                <td style={{ minWidth: "75px" }} className={`${styles.td} ${isClicked3Sp === pathway+index ? styles.clicked : ''}`}>
                  {qvalue}{" "}
                </td>
                <td style={{ minWidth: "60px" }} className={`${styles.td} ${isClicked3Sp === pathway+index ? styles.clicked : ''}`}>
                  {q_005}{" "}
                </td>
                <td style={{ minWidth: "60px" }} className={`${styles.td} ${isClicked3Sp === pathway+index ? styles.clicked : ''}`}>
                  {q_001}{" "}
                </td>
                <td style={{ minWidth: "60px" }} className={`${styles.td} ${isClicked3Sp === pathway+index ? styles.clicked : ''}`}>
                  {q_0001}{" "}
                </td>
                <td
                  style={{
                    maxWidth: "200px",
                    width: "100%",
                    textAlign: "left",
                  }}
                  className={`${styles.td} ${isClicked3Sp === pathway+index ? styles.clicked : ''}`}
                >
                  {pathway}
                </td>
                <td className={`${styles.td} ${isClicked3Sp === pathway+index ? styles.clicked : ''}`}>{source}</td>
                <td className={`${styles.td} ${isClicked3Sp === pathway+index ? styles.clicked : ''}`}>
                  {overlap}/{size}
                </td>
                <td className={`${styles.td} ${isClicked3Sp === pathway+index ? styles.clicked : ''}`}>{cancerLevel}</td>
                <td className={`${styles.td} ${isClicked3Sp === pathway+index ? styles.clicked : ''}`}>
                  <button
                    className={styles.btn}
                    onClick={() => {
                      setIsClicked3SP(pathway+index)
                      dataType === '0001' && setCordZcutoff(-Math.log10(q_0001_val));
                      dataType === '001' && setCordZcutoff(-Math.log10(q_001_val));
                      dataType === '005' && setCordZcutoff(-Math.log10(q_005_val));
                      setCordZ(-Math.log10(pvalue));
                      setCordX(size);
                    }}
                  >
                    Click
                  </button>
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Table3SP;
